"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// dude with hammers
exports.default = {
    skin: [{
        x: 5,
        y: 2,
        height: 5,
        width: 5
    }, {
        x: 13,
        y: 6,
        height: 2,
        width: 1
    }, {
        x: 1,
        y: 5,
        height: 2,
        width: 1
    }],
    face: [{
        x: 7,
        y: 3,
        height: 1,
        width: 1
    }, {
        x: 9,
        y: 3,
        height: 1,
        width: 1
    }],
    clothing_primary: [{
        x: 2,
        y: 5,
        height: 2,
        width: 1
    }, {
        x: 3,
        y: 6,
        height: 2,
        width: 10
    }],
    clothing_secondary: [{
        x: 5,
        y: 11,
        height: 2,
        width: 5
    }, {
        x: 5,
        y: 11,
        height: 6,
        width: 2
    }, {
        x: 10,
        y: 12,
        height: 4,
        width: 1
    }, {
        x: 11,
        y: 13,
        height: 3,
        width: 1
    }],
    weapon: [{
        x: 13,
        y: 3,
        height: 2,
        width: 3
    }, {
        x: 14,
        y: 3,
        height: 5,
        width: 1
    }, {
        x: 0,
        y: 1,
        height: 2,
        width: 3
    }, {
        x: 1,
        y: 1,
        height: 4,
        width: 1
    }],
    hair: [{
        x: 5,
        y: 0,
        height: 2,
        width: 1
    }, {
        x: 5,
        y: 1,
        height: 1,
        width: 2
    }, {
        x: 9,
        y: 0,
        height: 2,
        width: 1
    }, {
        x: 8,
        y: 1,
        height: 1,
        width: 2
    }],
    accent: [{
        x: 5,
        y: 6,
        height: 5,
        width: 1
    }, {
        x: 6,
        y: 7,
        height: 4,
        width: 1
    }, {
        x: 7,
        y: 8,
        height: 3,
        width: 1
    }, {
        x: 8,
        y: 7,
        height: 4,
        width: 1
    }, {
        x: 9,
        y: 6,
        height: 5,
        width: 1
    }]
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hash-heroes/lib/data/hero3.js
// module id = 351
// module chunks = 0